import React from "react";

const Seasons = () => {
  return <div>Reasons</div>;
};

export default Seasons;
